export default __webpack_public_path__ + "static/media/note.d0624ea4.svg";